import { CartLine } from './CartLine';

export type { TypeCartLineProps } from './types';
export default CartLine;
